import { render, staticRenderFns } from "./saledOrderDetail.vue?vue&type=template&id=3359c08e&scoped=true&"
import script from "./saledOrderDetail.vue?vue&type=script&lang=js&"
export * from "./saledOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./saledOrderDetail.vue?vue&type=style&index=0&id=3359c08e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359c08e",
  null
  
)

export default component.exports